import { shopPhoto } from '../../config/shops';
import WidthWrapperEx from '../layout/WidthWrapperEx';

export default function ShopGallery({ shop, t }) {
  return <section id="atmosfera" aria-labelledby="gallery-heading" className="py-14 lg:py-20">
    <WidthWrapperEx fullHeight={false} className="px-4 sm:px-6">
    <div className="flex flex-wrap items-end justify-between gap-5">
      <h2 id="gallery-heading" className="text-3xl font-black leading-tight tracking-tight sm:text-4xl">{t('experience.title')}</h2>
      <a href={shop.facebook} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center text-sm font-bold text-[var(--shop-accent)] underline underline-offset-4">{t('experience.facebook')} ↗</a>
    </div>
    <div className="mt-8 grid gap-5 sm:grid-cols-3">
      {shop.photos.map((photo, index) => <figure key={photo.file} className={index === 1 ? 'sm:pt-8' : ''}>
        <a href={shopPhoto(shop, photo)} target="_blank" rel="noopener noreferrer" className="group block overflow-hidden rounded-xl bg-[var(--shop-surface)]">
          <img src={shopPhoto(shop, photo, true)} width="640" height={Math.round(640 * photo.height / photo.width)} loading="lazy" decoding="async" alt={t(`${shop.slug}.photos.${photo.file}`)} className="aspect-[4/3] w-full object-cover transition-transform duration-300 motion-safe:group-hover:scale-105" style={{ objectPosition: photo.position }} />
        </a>
      </figure>)}
    </div>
    </WidthWrapperEx>
  </section>;
}
